import CompositionRow from './CompositionRow';

export default CompositionRow;
